<template>
    <div class="field grid">                
        <div class="col-12">            
            <DataTable :value="FuelSpecificData" responsiveLayout="scroll">
                <template #header>
                    <div class="flex justify-content-between p-ai-center">
                        <h5 class="m-0">{{ translated('fueladhocprice') }}</h5>
                        <!-- <Button v-if="(fuelAllOptions.length > FuelSpecificData.length) && !isMinisterstvo" icon="pi pi-plus" class="p-button-rounded p-button-secondary" @click="openModalAddFuelPrice" /> -->
                        <Button v-if="!isMinisterstvo && canIAddNew" icon="pi pi-plus" class="p-button-rounded p-button-secondary" @click="openModalAddFuelPrice" />
                    </div>
                </template>									
                <Column :header="translated('fueltable')" field="Fuel"></Column>
                <Column :header="translated('fuelsubtype')" field="OrganicGasType"></Column>
                <Column :header="translated('pricetable')" field="AdHocPricePerDeliveryUnit"></Column>
                <Column :header="translated('greenenergy')" field="GreenEnergy">
                    <template #body="slotProps">
                        {{ formatGreenEnergy(slotProps.data) }}
                    </template>	                
                </Column>
                <Column :exportable="false" :style="{width:'120px'}">
                    <template #body="slotProps">
                        <Button v-if="!isMinisterstvo" icon="pi pi-trash" class="p-button-rounded p-button-warning deletebutton" @click="deleteFuelPrice(slotProps.data)" />
                        <Button v-if="!isMinisterstvo" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2 editbutton" @click="openModalEditFuelPrice(slotProps.data)" />											
                    </template>
                </Column>								
            </DataTable>
        </div>                        
    </div>	  

<Dialog v-model:visible="displayModalAddFuelData" :style="{width: '30vw'}" :modal="true" class="globalDialog">
    <template #header>
		<span class="p-dialog-title">{{ FuelDataHeader }}</span>
	</template>	    
    <div class="card fluid">       

        <div class="field grid">
            <label for="name1" class="col-12 md:col-3 mb-md-0">{{ translated('fueltable') }}</label>
            <div class="col-12 md:col-9">
                <Dropdown v-model="tmpFuel" :options="tmpFuelAllMissingOptions" optionLabel="label" optionValue="value" placeholder="Select fuel" @change="fuelSelected" :disabled="isEdit" />													
            </div>                        
        </div>		

        <div v-if="displayOrganicGasType"class="field grid">
            <label for="name1" class="col-12 md:col-3 mb-md-0">{{ translated('fueltablebiogas') }}</label>
            <div class="col-12 md:col-9">
                <Dropdown v-model="tmpOrganicGasType" :options="tmpOrganicGasAllMissingOptions" optionLabel="label" optionValue="value" placeholder="Select fuel" :disabled="isEdit" />													
            </div>                        
        </div>	

        <div class="field grid">
            <label for="newevseid" class="col-12 md:col-3 mb-md-0">{{ translated('pricetable') }}</label>
            <div class="col-12 md:col-9">
                <InputNumber v-model="tmpPrice" mode="decimal" :minFractionDigits="2" locale="sl-SI" />					
            </div>  						
        </div>	
        <div v-if="displayGreen" class="field grid">
            <label for="newevseid" class="col-12 md:col-3 mb-md-0">{{ translated('greenenergy') }}</label>
            <div class="col-12 md:col-9">
                <InputNumber v-model="tmpGreen" mode="decimal" :minFractionDigits="2" locale="sl-SI" />					
            </div>  						
        </div>            													
    </div>
	<template #footer>
		<Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeModalAddFuelPrice" class="p-button-text"/>
		<Button :label="translated('savebutton')" icon="pi pi-check" @click="closeAndAddModalAddFuelPrice" autofocus />				
	</template>
</Dialog>

</template>

<script>
import { computed } from "vue"
import store from "@/store";

export default {
    props: ['FuelSpecificData'],
    emits: ["removeFuelData"],
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
            FuelDataHeader: '',
            displayModalAddFuelData : false,
            displayGreen: false,
            displayOrgancGasType: false,
            isEdit: false,
            tmpFuel: null,
            tmpOrganicGasType: null,
            tmpPrice: 0.0,
            tmpGreen: 0.0,
            tmpId: null,            
            fuelAllOptions: [
                {label: "Electric", value: "Electric"},
                {label: "Hydrogen", value: "Hydrogen"},
                {label: "OrganicGas", value: "OrganicGas"}
            ],
            organicgasAllOptions: [
                {label: "Biogas", value: "biogas"},
                {label: "CNG", value: "cng"},
                {label: "LNG", value: "lng"}
            ],
            tmpFuelAllMissingOptions: [],
            tmpOrganicGasAllMissingOptions: []
        }
    },
    created() {
        //console.log('KLIČEM CREATED od FuelData !!!!')
    },        
    mounted() {
        /*
        console.log('kličem MOUNTED od FuelData !');
        const lenAll = this.fuelAllOptions.length;
        const lenCurrent = this.FuelSpecificData.length;
        const tmpArr = {...this.FuelSpecificData};
        console.log(lenAll);
        console.log(lenCurrent);
        console.log(this.FuelSpecificData);
        this.tmpEnableAddButton = lenAll > lenCurrent;
        */
    },    
    computed: {
		isMinisterstvo() {
            return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
            //return (this.$store.getters.getRole=="MAdmin" || this.$store.getters.getRole=="MUser");
			//return true;
        },
        isReadOnly() {
            return this.$store.getters.isInRole("ReadOnly");
        },
        canIAddNew() {
            const arrBiogas = this.organicgasAllOptions.filter(item => {
                const objIndex=this.FuelSpecificData.findIndex(obj => obj.OrganicGasType == item.value)
                return objIndex == -1
            });
            

            const arr = this.fuelAllOptions.filter(item => {
                const objIndex=this.FuelSpecificData.findIndex(obj => obj.Fuel == item.value)
                return objIndex == -1
            });

            return arr.length > 0 || arrBiogas.length > 0;
        }
    },     
    methods: {
        openModalAddFuelPrice() {
            this.isEdit = false;
            this.FuelDataHeader = this.translated('newfuelprice'); //"Add new fuel price";
            this.tmpId = '00000000-0000-0000-0000-000000000000';
            this.displayModalAddFuelData = true;

            this.tmpGreen = 0.0;
            this.tmpPrice = 0.0;

            //console.log('podatki za this.FuelSpecificData');
            //console.log(this.FuelSpecificData);
            //console.log('izpisal zgoraj');
            const tmpArr = {...this.FuelSpecificData};
            //console.log(tmpArr);
            //console.log(Array.isArray(tmpArr));
            /*
            const arr = this.fuelAllOptions.filter(function(item) {

                let objIndex = null
                if(Array.isArray(tmpArr))
                    objIndex=this.FuelSpecificData.findIndex(obj => obj === item.Fuel) // item.value
                    */
                /*
                if (typeof this.FuelSpecificData !== 'undefined') {
                    if(this.FuelSpecificData.length>0)
                        objIndex=1;
                        //objIndex=this.FuelSpecificData.findIndex(obj => obj === 'nekaj') // item.value
                }
                  */  
            const arrBiogas = this.organicgasAllOptions.filter(item => {
                const objIndex=this.FuelSpecificData.findIndex(obj => obj.OrganicGasType == item.value)
                return objIndex == -1
            });
            this.tmpOrganicGasAllMissingOptions = arrBiogas


            const arr = this.fuelAllOptions.filter(item => {
                const objIndex=this.FuelSpecificData.findIndex(obj => obj.Fuel == item.value)
                return objIndex == -1
            });

            if(arrBiogas.length>0) {
                const objIndex = arr.findIndex(obj => obj.value == 'OrganicGas');

                if(objIndex == -1) {
                    // console.log('OrganicGas ni v FuelSpecificData', arr);
                    arr.push({label: "OrganicGas", value: "OrganicGas"});
                }
                    
            }

            this.tmpFuelAllMissingOptions = arr;
            //console.log(arr);

        },
        fuelSelected(eventdata){
            //console.log('event changed:');
            //console.log(eventdata);
            this.displayGreen = eventdata.value=='Electric' || eventdata.value=='Hydrogen';
            this.displayOrganicGasType = eventdata.value=='OrganicGas';
        },
        deleteFuelPrice(fuelDataObj) {
            this.$emit('removeFuelData', {id: fuelDataObj.Id, fuel: fuelDataObj.Fuel, organicGasType: fuelDataObj.OrganicGasType}); 

            /*
            const arr = this.FuelSpecificData.filter(item => item.Id != fuelDataObj.Id)
            this.FuelSpecificData = arr
            console.log(arr);
            */
        },
        openModalEditFuelPrice(fuelDataObj) {
            //console.log(fuelDataObj);
            this.isEdit = true;
            this.FuelDataHeader = this.translated('editfuelprice'); // "Edit fuel price";
            // tu moram nastaviti array za fuel, da dam na izbiro samo trenutni in tiste, ki še niso definirani!

            // const arr = this.fuelAllOptions.filter(item => {
            //     const objIndex=this.FuelSpecificData.findIndex(obj => obj.Fuel == item.value)
            //     return item.value == fuelDataObj.Fuel || objIndex == -1
            // })
            // this.tmpFuelAllMissingOptions = arr;



            this.tmpOrganicGasAllMissingOptions = this.organicgasAllOptions
            this.tmpFuelAllMissingOptions = this.fuelAllOptions;


            this.tmpGreen = fuelDataObj.GreenEnergy;
            this.tmpPrice = fuelDataObj.AdHocPricePerDeliveryUnit;
            this.tmpFuel = fuelDataObj.Fuel;
            this.tmpOrganicGasType = fuelDataObj.OrganicGasType;
            this.tmpId = fuelDataObj.Id;            
            this.displayGreen = fuelDataObj.Fuel=='Electric' || fuelDataObj.Fuel=='Hydrogen';
            this.displayOrganicGasType = fuelDataObj.Fuel=='OrganicGas';
            this.displayModalAddFuelData = true;
        },
        closeModalAddFuelPrice() {
            this.displayModalAddFuelData = false;
        },
        closeAndAddModalAddFuelPrice() {
            //console.log('id je:' + this.tmpId);
            if(this.tmpId===null)
                this.tmpId = '00000000-0000-0000-0000-000000000000';

            let greenPart = 100;
            if(this.tmpFuel=='Electric' || this.tmpFuel=='Hydrogen')
                greenPart = this.tmpGreen;

            const newFuelPrice = {
                AdHocPricePerDeliveryUnit: this.tmpPrice,
                Fuel: this.tmpFuel,
                OrganicGasType: this.tmpFuel != "OrganicGas" ? null : this.tmpOrganicGasType,
                Id: this.tmpId,
                GreenEnergy: greenPart
            }
            //console.log(newFuelPrice);

            if(this.tmpId == '00000000-0000-0000-0000-000000000000') {
                // Najprej poiščem, če mogoče že obstaja zapis z praznim Id-jem ter za to gorivo in moram upoštevati tudi OrganicGasType
                const objIndex=this.FuelSpecificData.findIndex(obj => obj.Fuel == this.tmpFuel && obj.OrganicGasType == this.tmpOrganicGasType)
                if(objIndex != -1) {
                    this.FuelSpecificData[objIndex] = newFuelPrice;
                } else {
                    this.FuelSpecificData.push(newFuelPrice)
                }
                
            } else {
                const objIndex=this.FuelSpecificData.findIndex(obj => obj.Id == this.tmpId)
                this.FuelSpecificData[objIndex] = newFuelPrice;
                //console.log('ID od iskanega objekta: ' + objIndex);
            }
            
            this.displayModalAddFuelData = false;
            
        },
        formatGreenEnergy(prop) {

            if(prop.Fuel=='OrganicGas')
                return ''

            return prop.GreenEnergy
        }
    }    

}
</script>

<style scoped>
 button.deletebutton, button.editbutton {
    position: relative;
    float: right;
}
</style>